module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"failed-retrieve-product":"Failed to retrieve product"}}')
  delete Component.options._Ctor
}
